import HeroSlider from "./HeroSlider";
import CadSketch from "./CadSketch";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden pt-24 pb-16 bg-white"
    >
      {/* CAD drawing background */}
      <CadSketch className="opacity-100" />
      <div className="absolute inset-0 radial-fade" />

      {/* Side stamp */}
      <div className="hidden lg:flex absolute left-6 top-1/2 -translate-y-1/2 flex-col items-center gap-4 font-mono text-[10px] tracking-[0.3em] text-[#8896A6] uppercase rotate-180" style={{ writingMode: "vertical-rl" }}>
        <span>MWP1110 · 04L 121 011</span>
        <span className="h-16 w-px bg-[#C8D3DF]" />
        <span>MultiParts Engineering</span>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full grid lg:grid-cols-12 gap-10 items-center relative z-10">
        {/* LEFT — copy */}
        <div className="lg:col-span-6 flex flex-col gap-7">
          <div className="flex items-center gap-3 reveal">
            <span className="spec-label">MPS MWP1110 · VW · Audi · Škoda · SEAT · Cupra</span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-chivo font-black text-[clamp(2.6rem,6vw,5.2rem)] leading-[0.92] tracking-tighter text-[#1A2232] reveal"
          >
            Engineered to <br />
            <span className="text-[#5B9BD5]">never overheat.</span>
          </h1>

          <p className="font-plex text-base lg:text-lg text-[#536073] leading-relaxed max-w-xl reveal">
            The MultiParts <span className="font-mono text-[#1A2232]">MWP1110</span> is a re-engineered switchable coolant pump for{" "}
            <span className="text-[#1A2232]">VW, Audi, Škoda, SEAT and Cupra</span> EA888 platforms — OE ref{" "}
            <span className="font-mono text-[#1A2232]">04L&nbsp;121&nbsp;011</span>. Proprietary flow geometry, a reinforced fail-safe spring, and a debris-shielded secondary pump. If it ever fails, it locks{" "}
            <span className="text-[#5B9BD5] font-semibold">OPEN</span>. The engine keeps cooling. The customer keeps driving.
          </p>

          <div className="flex flex-wrap gap-4 reveal">
            <a href="#cta" data-testid="hero-cta-primary" className="btn-tech">
              Get an offer <span aria-hidden>→</span>
            </a>
            <a href="#engineering" data-testid="hero-cta-secondary" className="btn-ghost">
              See the Engineering
            </a>
          </div>

          {/* mini-stat strip */}
          <div className="grid grid-cols-3 gap-4 pt-6 border-t border-[#C8D3DF] mt-2 reveal">
            {[
              { k: "4", v: "Critical Upgrades" },
              { k: "100%", v: "Fail-Safe Open" },
              { k: "0", v: "Flow Restrictions" },
            ].map((s, i) => (
              <div key={i} className="flex flex-col">
                <span className="font-chivo font-black text-3xl text-[#1A2232]">{s.k}</span>
                <span className="font-mono text-[10px] tracking-[0.2em] text-[#8896A6] uppercase mt-1">
                  {s.v}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT — product slider */}
        <div className="lg:col-span-6 relative reveal">
          <HeroSlider />
        </div>
      </div>

      {/* scroll cue */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10">
        <span className="font-mono text-[10px] tracking-[0.3em] text-[#8896A6] uppercase">
          Scroll
        </span>
        <div className="w-px h-10 bg-gradient-to-b from-[#5B9BD5] to-transparent" />
      </div>
    </section>
  );
}
